import { useEffect, useState } from 'react';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import PropTypes from 'prop-types';
import GoogleAnalytics from 'api/google_analytics';
import useIsLoggedIn from 'utils/hooks/use_is_logged_in';
import Login from 'tenants/sealink/auth/login';
import { useDocumentTitle } from 'tenants/sealink/utils/use_document_title';
import FindBooking from './find_booking';

const BookingManagement = ({ message = '' }) => {
  useDocumentTitle('Manage your booking');
  const [selectedRadio, setSelectedRadio] = useState(1);
  const isLogin = useIsLoggedIn();
  const hideLogin = window.ecom.craftConfig?.features?.loginSettings?.hideLogin;

  useEffect(() => {
    GoogleAnalytics.viewBookingManagement();
  }, []);

  return (
    <div className="container container--x-narrow d-flex flex-column gap-3">
      <div className="content">
        <h2>Manage your bookings</h2>
        <p>While managing your booking, you can:</p>
        <ul>
          <li>View your itinerary and booking documents</li>
          <li>Pay any outstanding amount on your booking</li>
          <li>Amend your booking (where possible)</li>
        </ul>
      </div>
      {!hideLogin && !isLogin && (
        <ToggleButtonGroup
          type="radio"
          name="options"
          defaultValue={1}
          className="w-100"
          onChange={(value) => setSelectedRadio(value)}
        >
          <ToggleButton
            id="tbg-radio-1"
            value={1}
            variant="outline-primary"
            className="w-50"
          >
            Find your bookings
          </ToggleButton>
          <ToggleButton
            id="tbg-radio-2"
            value={2}
            variant="outline-primary"
            className="w-50"
          >
            Login
          </ToggleButton>
        </ToggleButtonGroup>
      )}

      {selectedRadio === 1 && <FindBooking message={message} />}
      {selectedRadio === 2 && (
        <Login showTitle={false} successRedirectURL="account/history" />
      )}
    </div>
  );
};

export default BookingManagement;

BookingManagement.propTypes = {
  message: PropTypes.string,
};
